
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  PurchaseOrderProductInfos,
  TaxRefundInfo,
} from "@/model/FinancialBookingModels";
import { isEmpty, toUpper } from "lodash";
import { exchangeRate } from "@/api/booking-order";
import { LoadingPlanType } from "@/views/sales-management/SalesBookingOrderManagement.vue";

/**
 * 查看退税资料
 */
@Component({
  name: "AuditTable",
})
export default class extends Vue {
  @Prop({ required: true }) private data: TaxRefundInfo
  @Prop({ required: false, default: false }) private selectable: boolean;
  @Prop({ required: false, default: false }) private show: boolean;
  private data_: TaxRefundInfo = new TaxRefundInfo();

  @Watch("data", { deep: true, immediate: true })
  private watchData() {
    this.data_ = this.data;
  }

  private getinternationalTradeTerms(internationalTradeTerms: string) {
    return this.internationalTradeTermsOptions.filter(i => i.value === internationalTradeTerms)[0]?.label;
  }

  private showExtraDialog(rows) {
    this.$emit("showExtraDialog", rows);
  }
  private open() {
    this.$emit("update:show", true);
  }
  private close() {
    this.$emit("update:show", false);
  }
  private async changeRate() {
    await exchangeRate(this.data_.bookingOrderId, {
      exchangeRate: this.data_.modifiedExchangeRate,
    });
    this.$emit("updateTax", this.data_.bookingOrderId);
  }
  private copyRaxInfo() {
    const {
      totalDeclarationAmount,
      currencyUnit,
      bookingOrderCode,
      internationalTradeTerms,
      modifiedExchangeRate,
      deliveryCountry,
    } = this.data_;
    let value = `出口业务，销售总额（报关总金额）：${totalDeclarationAmount}，币种：${currencyUnit}，合同号：${bookingOrderCode}，成交方式：${this.getinternationalTradeTerms(internationalTradeTerms)}，汇率：${modifiedExchangeRate}，目的地（抵运国）：${deliveryCountry}`;
    const input = document.createElement("input");
    document.body.appendChild(input);
    input.setAttribute("value", value);
    input.select();
    if (document.execCommand("copy")) {
      document.execCommand("copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
    }
    document.body.removeChild(input);
  }

  private internationalTradeTermsOptions = [
    { label: "FOB", value: "1" },
    { label: "CIF", value: "2" },
    { label: "C&F", value: "3" },
    { label: "DPU", value: "4" }
  ];
}

export class LoadingPlanListTableRowData {
  id: string;
  code: string;
  createdDate: string;
  containerType: string;
  type: LoadingPlanType;
  category: string;
  loadingPlace: string;
  containerInfo: string;
  totalProductQuantity: number;
  totalAmount: string;
  totalVolume: string;
  select: boolean;

  isMatch(code?: string, category?: string, factoryName?: string): boolean {
    let match = true;
    if (!isEmpty(code)) {
      match = this.code.includes(toUpper(code));
    }
    if (!isEmpty(category)) {
      match = match && this.category === category;
    }
    if (!isEmpty(factoryName)) {
      match = match && this.loadingPlace.includes(factoryName);
    }
    return match;
  }
}
